import { Component } from 'react';
import { reportError } from '../../error-reporting/reportError';
import { buildError } from '../../error-reporting/builders/buildError';
import FatalError from './FatalError';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
    this.reset = this.reset.bind(this);
    this.handleReportError = this.handleReportError.bind(this);
  }
  componentDidCatch(error, info) {
    const {
      shouldAutoReset
    } = this.props;
    if (!shouldAutoReset || !shouldAutoReset(error)) {
      this.setState({
        hasError: true
      });
      this.handleReportError(error, info);
    }
  }
  handleReportError(error, info) {
    const {
      errorLoggingTitle,
      errorBoundaryName,
      onGetComponentDataForLogging,
      getLogLevel
    } = this.props;
    const {
      message
    } = error;
    const {
      componentStack
    } = info;
    const componentError = buildError(['Component caught', errorLoggingTitle, message].join(': '), {
      name: 'ComponentError',
      componentStack,
      errorBoundaryName
    }, error);
    reportError({
      error: componentError,
      tags: {
        componentDidCatch: true,
        isVisibleToUser: true
      },
      componentData: onGetComponentDataForLogging ? onGetComponentDataForLogging() : undefined,
      level: getLogLevel ? getLogLevel(error) : undefined
    });
  }
  reset() {
    this.setState({
      hasError: false
    });
  }
  renderDefaultError() {
    return /*#__PURE__*/_jsx(FatalError, {});
  }
  render() {
    const {
      children,
      renderError: passedRenderError
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError) {
      const renderError = passedRenderError || this.renderDefaultError;
      return renderError({
        reset: this.reset
      });
    }
    return children;
  }
}
ErrorBoundary.displayName = 'ErrorBoundary';